import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import DropDownButton from 'devextreme-react/drop-down-button';
import React, { useEffect, useState, useRef } from "react";
import * as DinamicQueries from '../../api/DinamicsQuery';
import { SelectBox } from 'devextreme-react/select-box';
import { CheckBox } from 'devextreme-react/check-box';
import { DateBox } from 'devextreme-react/date-box';
import LoadPanel from 'devextreme-react/load-panel';
import { Button } from "devextreme-react/button";
import { saveAs } from 'file-saver';
import pptxgen from "pptxgenjs";
import Moment from "moment";
import jsPDF from 'jspdf';
import JSZip, { filter } from 'jszip';
// ia
import { getFunctions, httpsCallable } from "firebase/functions";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

// Inicializar Firebase
const functions = getFunctions();
const storage = getStorage();
export default function GalleryIA3() {
    const [Establecimito, setEstablecimito] = useState([]);
    const [Formularios, setFormularios] = useState([]);
    const [tags, setTags] = useState([]);
    const [cadenas, setCadenas] = useState([]);
    const [Clientes, setClientes] = useState([]);
    const [Regiones, setRegiones] = useState([]);
    const [usuario, setUsuario] = useState([]);
    const [ImagesSelected, setImagesSelected] = useState([]);
    const [resgistros, setRegistros] = useState([]);
    const [LoadPanelBoolean, setLoadPanelBoolean] = useState(false);
    const [selectedAll, setselectedAll] = useState(false);
    const [fechaInicial, setfechaInicial] = useState(
        new Date(new Date().setDate(new Date().getDate() - 7))
    );

    const [currentIndex, setCurrentIndex] = useState(0);

    const [FechaFinal, setFechaFinal] = useState(new Date());
    const now = new Date();

    const InitialStateFilters = {
        cliente: '',
        formulario: '',
        region: '',
        fechaInicial: new Date(new Date().setDate(new Date().getDate() - 7)),
        fechaFinal: new Date(),
        usuarios: '',
        Establecimientos: '',
        cadenas: 'TODAS',
        tag: "TODOS"
    };
    const [filters, setFilters] = useState(InitialStateFilters);
    const [infoSelected, setinfoSelected] = useState(false);

    const [toastConfig, setToastConfig] = React.useState(
        {
            isVisible: false,
            type: "success",
            message: "Busqueda Exitosa",
            displayTime: 2000,
        },
        []
    );

    const options = ["Zip", "PDF"];
    // "Power Point"


    const styleContador = {
        fontFamily: 'Arial, sans-serif',
        fontSize: '17px',
        fontWeight: 'bold',
        textAlign: 'center',
        color: '#fff',
        backgroundColor: '#f49f3c',
        padding: '5px',
        borderRadius: '5px',
        height: "30px"
    };


    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("userData"));
        setClientes(user.cliente);
        setRegiones(user.region);
        setFilters({ ...filters, region: user.region[0] })
        SearchTag()
        searchCadena()
        localStorage.removeItem("photosSelected")
    }, [])

    const SearchTag = () => {
        DinamicQueries.getData('getTag', 'formularios/').then((resp) => {
            console.log(resp.data.data[0].tags)
            resp.data.data[0].tags.unshift("TODOS")
            setTags(resp.data.data[0].tags);
        });
    }

    const searchCadena = () => {
        DinamicQueries.getData('getCadenas', 'EstablecimientosNuevos/').then((resp)=>{
            resp.data.unshift({nombre_cadena: "TODAS"})
            setCadenas(resp.data)
        });
    };

    const searchFormulario = (e) => {
        console.log(e)
        if (e.value != "") {
            setFilters({ ...filters, cliente: e.value });
            DinamicQueries.getDataWithParameters('getFormsWeb', 'formularios/', { cliente: e.value }).then((resp) => {
                setFormularios(resp.data.data);
            });
        }
    };

    const clearFilters = () => {
        setFilters(InitialStateFilters);
        localStorage.removeItem("photosSelected")
        setRegistros([])
    };

    const serachPictures = async () => {
        if (!selectedImage) {
            alert("Debe cargar una imagen del planograma antes de continuar.");
            return;
        }
    
        setIsLoading(true);
    
        try {
            // 📤 Subir la imagen del planograma a Firebase Storage
            const storageRef = ref(storage, `Planograma IA3/${selectedImage.name}`);
            await uploadBytes(storageRef, selectedImage);
            const planogramaUrl = await getDownloadURL(storageRef);
    
            console.log("✅ Imagen del planograma subida:", planogramaUrl);
            setPlanogramaUrl(planogramaUrl); // Guarda la URL en el estado
    
            // 🗂 Formatear fechas
            const fechaInicialFormat = Moment(filters.fechaInicial).format("YYYY-MM-DD");
            const fechaFinalFormat = Moment(filters.fechaFinal).format("YYYY-MM-DD");
    
            setRegistros([]);
            localStorage.removeItem("photosSelected");
    
            // 🔍 Consultar imágenes del filtro
            const resp = await DinamicQueries.getDataWithParameters('getImages', 'galeria/', {
                cliente: filters.cliente,
                nombre: filters.formulario,
                region: filters.region,
                fechaInicio: fechaInicialFormat,
                fechaFin: fechaFinalFormat,
                promotor: filters.usuarios,
                establecimiento: filters.Establecimientos,
                cadena: filters.cadenas,
            });
    
            let registrosConFotos = [];
            if (resp && resp.data) {
                registrosConFotos = resp.data.filter(element => element.fotos && element.fotos.length > 0);
            }
    
            registrosConFotos.sort((a, b) => a.establecimiento.localeCompare(b.establecimiento));
            setRegistros(registrosConFotos);
            setImagesSelected([]);
    
            // 📸 Extraer URLs de imágenes de anaqueles
            const todasLasFotos = registrosConFotos.flatMap(cadaRegistro => 
                (cadaRegistro.fotos || []).map(foto => foto.foto)
            );
    
            console.log("✅ Todas las imágenes del anaquel:", todasLasFotos);
    
            if (todasLasFotos.length > 0) {
                // 🔥 Enviar todo a la IA
                realizarConsulta(todasLasFotos, planogramaUrl);
            } else {
                alert("Debe seleccionar al menos una imagen del anaquel.");
            }
        } catch (error) {
            console.error("❌ Error obteniendo imágenes:", error);
        } finally {
            setIsLoading(false);
        }
    };    
    
    


    const searchUsersAndStablishment = (e) => {
        let Establecimientos = [];
        let Usuarios = [];
        if (e.element.innerText === 'Region') {
            if (e.value != "") {
                setFilters({ ...filters, region: e.value })
                DinamicQueries.getDataWithParameters('getEstablecimientosFilter', "galeria/", { cliente: filters.cliente, region: e.value })
                    .then(establecimientos => {
                        Establecimientos = [{
                            nombre_establecimiento: 'TODOS LOS ESTABLECIMIENTOS',
                        }, ...establecimientos.data]
                        setEstablecimito(Establecimientos)
                    })

                DinamicQueries.getDataWithParameters('getUserClientAndRegion', "usuarios/", { cliente: filters.cliente, region: e.value })
                    .then(usuarios => {
                        Usuarios = [{ nombre: "TODOS LOS USUARIOS", uid: "TODOS LOS USUARIOS" }, ...usuarios.data]
                        setUsuario(Usuarios)
                    })
            }
        } else if (e.element.innerText === 'Cliente') {
            if (e.value != "") {
                setFilters({ ...filters, cliente: e.value });
                DinamicQueries.getDataWithParameters('getEstablecimientosFilter', "galeria/", { cliente: e.value, region: filters.region })
                    .then(establecimientos => {
                        Establecimientos = [{
                            nombre_establecimiento: 'TODOS LOS ESTABLECIMIENTOS',
                        }, ...establecimientos.data]
                        setEstablecimito(Establecimientos)
                    })

                DinamicQueries.getDataWithParameters('getUserClientAndRegion', "usuarios/", { cliente: e.value, region: filters.region })
                    .then(usuarios => {
                        Usuarios = [{ nombre: "TODOS LOS USUARIOS", uid: "TODOS LOS USUARIOS" }, ...usuarios.data]
                        setUsuario(Usuarios)
                    })
            }
        }
    };


    const handleClick = async (url, registro) => {
        console.log(url)
        const data = await fetch(url.foto);
        const blob = await data.blob();
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
                const base64data = reader.result;
                console.log(base64data)
                // resolve(base64data);
                var a = document.createElement("a"); //Create <a>
                // a.href = "data:image/png;base64," + ImageBase64; //Image Base64 Goes here
                a.href = base64data //Image Base64 Goes here

                let tipo = ""

                var data = base64data.substring(0, 5);

                switch (data.toUpperCase()) {
                    case "IVBOR": tipo = "png";
                        break
                    case "/9J/4": tipo = "jpeg";
                        break
                    case "JVBER": tipo = "pdf";
                        break
                    case "UESDB":
                        var data2 = base64data.substring(0, 19);
                        switch (data2.toUpperCase()) {
                            case "UEsDBBQABgAIAAAAIQB": tipo = "xlsx";
                                break
                            default:
                                var data3 = base64data.substring(0, 18);

                                switch (data3.toUpperCase()) {
                                    case "UESDBBQABGAIAAAAIQ": tipo = "docx";
                                        break
                                    default: tipo = "zip";
                                }
                        }
                        break
                    case "UMFYI": tipo = "rar";
                        break
                    case "U1PKC": tipo = "txt";
                        break
                    default:
                        console.log("")
                        break
                }
                // registro.establecimiento +"-"+  url.tag + "-" + url.descripcion
                a.download = url.descripcion + "." + tipo //File name Here
                a.click(); //Downloaded file
            }
        });
    }

    const savePhoto = (photo) => {
        console.log(photo)
        if (localStorage.getItem('photosSelected') != undefined) {
            let photos = localStorage.getItem('photosSelected').split(',');
            console.log(photos)
            const found = photos.findIndex(element => element === photo.foto);
            if (found >= 0) { // existe, hay que eliminarlo
                photos.splice(found, 1)
            } else {
                photos.push(photo.foto)
            }

            localStorage.setItem('photosSelected', photos.toString())

        } else {
            let data = [photo.foto]
            localStorage.setItem('photosSelected', data.toString())
        }

        let info = localStorage.getItem('photosSelected').split(',')

        console.log(localStorage.getItem('photosSelected').split(','))
        let data = localStorage.getItem('photosSelected').split(',').filter(x => x !== '')
        setImagesSelected(data)

        if (info[0] === '' && info.length === 1) {
            setinfoSelected(false)
        } else {
            setinfoSelected(true)
        }
    }

    const DescargarSelectedZip = async () => {
        let photos = localStorage.getItem('photosSelected').split(',');
        console.log(photos)

        let images = []
        resgistros.forEach(x => {
            if (x.fotos.length > 0) {
                x.fotos.forEach(cadaFoto => {
                    photos.forEach(y => {
                        if (y == cadaFoto.foto) {
                            images.push({ url: cadaFoto.foto, name: x.establecimiento + "-" + cadaFoto.tag + "-" + cadaFoto.descripcion })
                        }
                    })
                })
            }
        })

        // console.log(images)
        let dataFinal = images.filter(x => x.url !== '')
        // console.log(dataFinal)
        const zip = new JSZip();

        let contador = 0
        dataFinal.forEach((url, index) => {
            // Carga la imagen como un blob
            fetch(url.url)
                .then(res => res.blob())
                .then(blob => {
                    // Agrega la imagen al archivo ZIP
                    // zip.file(`image${index}.jpg`, blob);
                    contador++
                    zip.file(contador + "- " + `${url.name}.jpg`, blob);
                    if (contador === dataFinal.length) {
                        // Cuando se hayan agregado todas las imágenes, genera el archivo ZIP
                        zip.generateAsync({ type: 'blob' }).then(content => {
                            // Descarga el archivo ZIP
                            console.log("Aquiiii")
                            console.log(content)
                            setLoadPanelBoolean(false)
                            saveAs(content, 'RegistroFotografico.zip');
                        });
                    }
                });
        });
    }

    const DescargarAllZip = () => {

        let images = []
        resgistros.forEach(x => {
            if (x.fotos.length > 0) {
                x.fotos.forEach(cadaFoto => {
                    images.push({ url: cadaFoto.foto, name: x.establecimiento + "-" + cadaFoto.tag + "-" + cadaFoto.descripcion })
                })
            }
        })
        const zip = new JSZip();
        let contador = 0
        images.forEach((url, index) => {
            // Carga la imagen como un blob
            fetch(url.url)
                .then(res => res.blob())
                .then(blob => {
                    // Agrega la imagen al archivo ZIP
                    contador++
                    zip.file(contador + "- " + `${url.name}.jpg`, blob);
                    if (contador === images.length) {
                        // Cuando se hayan agregado todas las imágenes, genera el archivo ZIP
                        zip.generateAsync({ type: 'blob' }).then(content => {
                            // Descarga el archivo ZIP
                            setLoadPanelBoolean(false)
                            saveAs(content, 'RegistroFotografico.zip');
                        });
                    }
                });
        });
    }

    const DescargarInfo = (e) => {
        console.log(e)
        setLoadPanelBoolean(true)
        if (ImagesSelected.length == 0) {
            if (e.itemData === "Zip") {
                DescargarAllZip()
            } else if (e.itemData === "Power Point") {
                DescargarAllPowerPoint()
            } else if (e.itemData === "PDF") {
                DescargarAllPdf()
            }
        } else {
            if (e.itemData === "Zip") {
                DescargarSelectedZip()
            } else if (e.itemData === "Power Point") {
                DescargarSelectedPowerPoint()
            } else if (e.itemData === "PDF") {
                DescargarSelectedPdf()
            }
        }
    }

    const DescargarAllPdf = () => {

        let images = []
        resgistros.forEach(x => {
            if (x.fotos.length > 0) {
                x.fotos.forEach(cadaFoto => {
                    images.push({ url: cadaFoto.foto, name: x.establecimiento + "-" + cadaFoto.tag + "-" + cadaFoto.descripcion })
                })
            }
        })
        console.log(images)
        const doc = new jsPDF();
        let contador = 0
        images.forEach((url, index) => {
            // Carga la imagen como un objeto Image de HTML
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = () => {
                // Agrega la imagen al PDF

                contador++
                const width = doc.internal.pageSize.getWidth();
                const height = (img.height * width) / img.width;
                doc.addImage(img, 'JPEG', 0, 20, width, height);
                if (contador === images.length) {
                    // Cuando se hayan agregado todas las imágenes, guarda el PDF
                    console.log("Aquiiii")
                    setLoadPanelBoolean(false)
                    doc.save('RegistroFotografico.pdf');
                } else {
                    // Agrega una nueva página antes de agregar la siguiente imagen
                    console.log("Aquiiii")
                    // doc.addFont(url.descripcion)
                    // doc.setTextColor("black")
                    // doc.text(url.descripcion, 10, 200);
                    doc.text(url.name === "" || url.name === undefined || url.name === null ? "Image" : url.name, 10, 10);

                    // Agregar el nuevo texto encima del texto original
                    doc.setFontSize(12);
                    doc.addPage();
                }
            };
            img.src = url.url;
        });
    }

    const DescargarSelectedPdf = async () => {
        let photos = localStorage.getItem('photosSelected').split(',');
        console.log(photos)



        let images = []
        resgistros.forEach(x => {
            if (x.fotos.length > 0) {
                x.fotos.forEach(cadaFoto => {
                    photos.forEach(y => {
                        if (y == cadaFoto.foto) {
                            images.push({ url: cadaFoto.foto, name: x.establecimiento + "-" + cadaFoto.tag + "-" + cadaFoto.descripcion })
                        }
                    })
                })
            }
        })

        console.log(images)

        let dataFinal = images.filter(x => x !== '')
        console.log(dataFinal)

        const doc = new jsPDF();
        let contador = 0
        dataFinal.forEach((url, index) => {
            // Carga la imagen como un objeto Image de HTML
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = () => {
                // Agrega la imagen al PDF
                const width = doc.internal.pageSize.getWidth();
                const height = (img.height * width) / img.width;
                doc.text(url.name === "" || url.name === undefined || url.name === null ? "Image" : url.name, 10, 10);
                doc.setFontSize(12);
                doc.addImage(img, 'JPEG', 0, 20, width, height);
                contador++
                console.log(contador)
                if (contador === images.length) {
                    console.log("Aquiiii")
                    setLoadPanelBoolean(false)
                    doc.save('RegistroFotografico.pdf');
                } else {
                    console.log("Aquiiii")
                    // doc.text(url.name === "" || url.name === undefined || url.name === null ? "Image" : url.name, 10, 10);
                    // doc.setFontSize(12);
                    doc.addPage();
                }
            };
            img.src = url.url;
        });
    }


    const DescargarAllPowerPoint = () => {

        let images = []
        resgistros.forEach(x => {
            if (x.fotos.length > 0) {
                x.fotos.forEach(cadaFoto => {
                    images.push(cadaFoto.foto)
                })
            }
        })
        // console.log(images)
        const pptx = new pptxgen();

        images.forEach((image) => {
            // Carga la imagen como un objeto Image de HTML
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.src = image;
            img.onload = () => {
                // Agrega una diapositiva a la presentación
                const slide = pptx.addSlide();

                // Agrega la imagen a la diapositiva
                slide.addImage({ data: img.src, x: 1, y: 2, w: 5, h: 3 });

                // Descarga la presentación de PowerPoint una vez que se hayan agregado todas las imágenes
                console.log(pptx.slides.length, "===", images.length)
                if (pptx.slides.length === images.length - 1) {
                    console.log("Aqui")
                    setLoadPanelBoolean(false)
                    pptx.writeFile('images.pptx');
                }
            };
        });
    }

    const DescargarSelectedPowerPoint = async () => {
        let photos = localStorage.getItem('photosSelected').split(',');
        console.log('photos',photos)
        // photos.forEach(async x => {
        //     if (x != '') {

        let dataFinal = photos.filter(x => x !== '')
        console.log(dataFinal)

        const pptx = new pptxgen();

        dataFinal.forEach((image) => {
            // Carga la imagen como un objeto Image de HTML
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.src = image;
            img.onload = () => {
                // Agrega una diapositiva a la presentación
                const slide = pptx.addSlide();

                console.log(img)
                // Agrega la imagen a la diapositiva
                slide.addImage({ data: img.src, x: 1, y: 2, w: 5, h: 3 });
                console.log(pptx.slides)
                console.log(dataFinal.length)

                // Descarga la presentación de PowerPoint una vez que se hayan agregado todas las imágenes
                console.log(pptx.slides.length, "===", dataFinal.length)
                if (pptx.slides.length === dataFinal.length) {
                    console.log("Aqui")
                    setLoadPanelBoolean(false)
                    pptx.writeFile('images.pptx');
                }
            };
        });
    }

    const selectAll = () => {
        const newData = [...resgistros];
        newData.forEach(element => {
            if (element.fotos !== undefined) {
                element.fotos.forEach(x => {
                    // if (x.foto == fotos.foto){
                    x.selected = true
                    // }
                })
            }
        });
        setRegistros(newData)
        setselectedAll(true)
    }

    const DeselectAll = () => {
        const newData = [...resgistros];
        newData.forEach(element => {
            if (element.fotos !== undefined) {
                element.fotos.forEach(x => {
                    // if (x.foto == fotos.foto){
                    x.selected = false
                    // }
                })
            }
        });
        setRegistros(newData)
        setselectedAll(false)
    }

    const buttonDropDownOptions = { width: 300 };

    // ia

    const getOpenAIResponse = httpsCallable(functions, "getOpenAIResponse");
    
      const [inputText, setInputText] = useState(""); // Entrada de texto opcional
      const [selectedImage, setSelectedImage] = useState(null); // Imagen seleccionada
      const [isLoading, setIsLoading] = useState(false);
      const [resultado, setResultado] = useState("");
      const [error, setError] = useState(null);

      const [resultadosIA, setResultadosIA] = useState([]);
      const [planogramaUrl, setPlanogramaUrl] = useState("");
    
      const handleRemoveImage = () => {
        setSelectedImage(null);
      };

      const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;
    
        setSelectedImage(file); // Solo guardamos el archivo en el estado
    };
    
      const realizarConsulta = async (todasLasFotos, planogramaUrl) => {
        console.log("🖼️ Fotos Anaquel (URLs):", todasLasFotos);
        console.log("🖼️ Foto Planograma (URLs):", planogramaUrl);
    
        if (!Array.isArray(todasLasFotos) || todasLasFotos.length === 0) {
            console.warn("⚠️ Error: todasLasFotos no es un array válido o está vacío.");
            setError("Error: No hay imágenes del anaquel para analizar.");
            return;
        }

        if (!planogramaUrl) {
            console.warn("⚠️ Error: No se encontró la URL del planograma.");
            setError("Error: No se ha cargado un planograma.");
            return;
        }
    
        setIsLoading(true);
        setError(null);
    
        try {
            const resultados = await Promise.all(
                todasLasFotos.map(async (fotoUrl) => {
                    const conversation = [
                        {
                            role: "system",
                            content: "JSON. Eres un asistente de una empresa de merchandising. Tu tarea es comparar dos imagenes. La primera imagen es un planograma de como se espera que esté organizado un anaquel. La segunda imagen es la foto directa del anaquel en la tienda. Tu deber es comparar ambas imagenes para corroborar que se cumpla con el planograma e indicar si se cumple o no (mostrar un mensaje que siga si se cumple con el planograma, o, no se cumple con el planograma). Además de eso, necesito que muestres el nombre del producto, la marca, el precio asociado al mismo, el color del producto, las unidades visibles del producto, y la ubicación en la segunda imagen, es decir en el anaquel. De no visualizarse alguno de estas características, debes poner un (No visible) o (No encontrado). También debes especificar, cuando compares ambas imagenes, que productos no se encuentran en el Anquel pero sí en el Planograma. No quiero que le coloques ninguna palabra en negrillas, no uses asteriscos ni numerales ( * ) ( # )"
                        },
                        {
                            role: "user",
                            content: "JSON. Por favor, compara las dos imagenes, el Planograma y el Anquel y proporciona una descripción detallada de todos y cada uno de los productos visibles en el Anaquel, incluye nombre, marca, precio, unidades (cantidad de productos visibles en la imagen pero solo de la primera cara tanto en el Anaquel como en el Planograma, sin tener en cuenta los productos que están detras del anaquel, solo la primera cara visible en las dos imagenes) y ubicación. Si no puedes especificar alguno de los valores mencionados porque no se encuentran, coloca (No visible) o (No encontrado). También especifica el color del producto. También debes especificar, cuando compares ambas imagenes, que productos no se encuentran en el Anquel pero sí en el Planograma. Necesito que menciones cada producto una sola vez analiza la imagen del planograma como un todo, y el anaquel como un todo, como un bloque, para que así no dupliques información; de igual manera, haz una verificación a la respuesta que me diste y quita la información de productos duplicados. Muy importante, de no cumplirse el Planograma al comparar ambas imagenes, necesito que redactes una breve explicación del porqué no se cumple, ya sea por las marcas de los productos, o porque son productos diferentes los que se encuentran en el Planograma y en el Anaquel, cualquier información sobre porqué no se cumple. Además necesito que agregues un porcentaje de que tanto se cumple con el planograma, donde 100% es que se cumple por completo y 0% es que no se cumple para nada. Necesito esa informacion también para ver que tan parecidos están los anaqueles al planograma así que agrega eso a los detalles del porqué no coinciden. Si aparece una persona en el planograma o en el anaquel omitela por completo."},
                        {
                            role: "user",
                            content: [
                                { type: "text", text: "Imagen del Planograma a comparar." },
                                { type: "image_url", image_url: { url: planogramaUrl } },
                                { type: "text", text: "Imagen del Anaquel para análisis." },
                                { type: "image_url", image_url: { url: fotoUrl } }
                            ]
                        }
                    ];
    
                    console.log("📨 Enviando consulta a OpenAI con planograma:", planogramaUrl, " y anaquel:", fotoUrl);
    
                    try {
                        const response = await getOpenAIResponse({ conversation });
                        return { fotoUrl, resultado: response.data.trim() };
                    } catch (err) {
                        console.error("❌ Error en la consulta de OpenAI:", err);
                        return { fotoUrl, resultado: "Error al obtener respuesta" };
                    }
                })
            );
    
            console.log("✅ Respuestas obtenidas:", resultados);
    
            // Almacenar las respuestas en el estado `resultadosIA`
            setResultadosIA(resultados);
    
        } catch (err) {
            console.error("❌ Error general en la consulta:", err);
            setError(`Error al realizar la consulta: ${err.message}`);
        } finally {
            setIsLoading(false);
        }
    };    

    return (
        <div height="100%">
            <div className="d-md-flex justify-content-between pruebaBoton">
                <h5 className={"content-block titleCliente"}>Registro Fotografico IA 3</h5>
                <div style={{ display: "flex", width: "45%" }}>
                    <Button className="btn btn-light mt-4 mr-2" onClick={clearFilters}>Limpiar Filtros</Button>
                    {/* <Button className="btn btn-primary mt-4 mr-2" onClick={DescargarSelected} disabled={!infoSelected}>Descargar seleccionados</Button>
                        <Button className="btn btn-primary mt-4 mr-2" onClick={DescargarAll} disabled={resgistros.length < 0}>Descargar todos</Button> */}
                    <DropDownButton
                        className="btn mt-3 mr-2"
                        style={{ height: "50px" }}
                        text="Descargar"
                        icon="donwload"
                        dropDownOptions={buttonDropDownOptions}
                        items={options}
                        onItemClick={(e) => {
                            DescargarInfo(e)
                        }}
                        disabled={resgistros.length == 0}
                    />

                    {/* <SelectBox
                            style={{height:"50px", margin:"15px", height:"50px"}}
                            searchEnabled
                            label='Descargar'
                            onValueChanged={(e) => { DescargarInfo(e);}}
                            dataSource={options}
                        /> */}

                    {selectedAll == true ? (
                        <Button className="btn btn-primary mt-4 mr-2" onClick={DeselectAll} disabled={resgistros.length == 0}>Deseleccionar</Button>
                    ) : (
                        <Button className="btn btn-primary mt-4 mr-2" onClick={selectAll} disabled={resgistros.length == 0}>Seleccionar todos</Button>
                    )}

                    <Button className="btn btn-primary mt-4 mr-2" onClick={serachPictures}>Buscar</Button>
                </div>

            </div>

            <div className="row">
                <div className="col-md-4 mt-4">
                    <SelectBox
                        searchEnabled
                        label='Cliente'
                        onValueChanged={(e) => { searchFormulario(e); searchUsersAndStablishment(e) }}
                        dataSource={Clientes}
                        defaultValue={filters.cliente}
                        value={filters.cliente}
                    />
                </div>
                <div className="col-md-4 mt-4">
                    <SelectBox
                        searchEnabled
                        label='Formularios'
                        dataSource={Formularios}
                        valueExpr="nombre"
                        displayExpr="nombre"
                        defaultValue={filters.formulario}
                        value={filters.formulario}
                        onValueChanged={(e) => {
                            setFilters({
                                ...filters,
                                formulario: e.value,
                            })
                        }
                        }
                    />
                </div>
                <div className="col-md-4 mt-4">
                    <DateBox
                        label='Desde'
                        onValueChanged={(e) =>
                            setFilters({
                                ...filters,
                                fechaInicial: e.value,
                            })
                        }
                        defaultValue={fechaInicial}
                        value={fechaInicial}
                        max={now}
                        type='date'
                    />
                </div>
                <div className="col-md-4 mt-4">
                    <DateBox
                        label='Hasta'
                        onValueChanged={(e) =>
                            setFilters({
                                ...filters,
                                fechaFinal: e.value,
                            })
                        }
                        defaultValue={FechaFinal}
                        value={FechaFinal}
                        max={now}
                        type='date'
                    />
                </div>
                <div className="col-md-4 mt-4">
                    <SelectBox
                        searchEnabled
                        label='Region'
                        dataSource={Regiones}
                        defaultValue={filters.region}
                        value={filters.region}
                        onValueChanged={(e) => { searchUsersAndStablishment(e) }}
                    />
                </div>
                <div className="col-md-4 mt-4">
                    <SelectBox
                        label='Usuarios'
                        dataSource={usuario}
                        defaultValue={filters.usuarios}
                        value={filters.usuarios}
                        valueExpr="uid"
                        displayExpr="nombre"
                        onValueChange={(e) => {
                            setFilters({
                                ...filters,
                                usuarios: e,
                            })
                        }}
                        searchEnabled={true}
                        disabled={filters.region !== '' && filters.cliente !== '' ? false : true}
                    />
                </div>

                <div className="col-md-4 mt-4">
                    <SelectBox
                        label='Establecimientos'
                        dataSource={Establecimito}
                        defaultValue={filters.Establecimientos}
                        value={filters.Establecimientos}
                        valueExpr="nombre_establecimiento"
                        displayExpr="nombre_establecimiento"
                        onValueChanged={(e) => {
                            setFilters({
                                ...filters,
                                Establecimientos: e.value,
                            })
                        }
                        }
                        searchEnabled={true}
                        disabled={filters.region !== '' && filters.cliente !== '' ? false : true}
                    />
                </div>

                <div className="col-md-4 mt-4">
                    <SelectBox
                        label='Cadena'
                        dataSource={cadenas}
                        defaultValue={filters.cadenas}
                        value={filters.cadenas}
                        valueExpr="nombre_cadena"
                        displayExpr="nombre_cadena"
                        onValueChanged={(e) => {
                            setFilters({
                                ...filters,
                                cadenas: e.value,
                            })
                        }}
                        searchEnabled={true}
                        disabled={filters.region !== '' && filters.cliente !== '' ? false : true}
                    />
                </div>

                <div className="col-md-4 mt-4">
                    <SelectBox
                        label='Etiquetas'
                        dataSource={tags}
                        defaultValue={filters.tag}
                        value={filters.tag}
                        onValueChanged={(e) => {
                            setFilters({
                                ...filters,
                                tag: e.value,
                            })
                        }
                        }
                        searchEnabled={true}
                    />
                </div>

                <div className="col-md-12 mt-4">
                    {ImagesSelected.length === 0 ? (
                        resgistros.length > 0 && (
                            <div style={styleContador}>Se descargaran todas las imagenes</div>
                        )
                    ) : (
                        <div style={styleContador} >Se descargaran {ImagesSelected.length} imagenes</div>
                    )}
                </div>
            </div>

            <div className="container-fluid min-vh-100 d-flex flex-column bg-light py-5">
            <div className="row">
</div>
<div>

<div className="container">
  <div className="row d-flex align-items-stretch">
    {/* Columna izquierda - Planograma */}
    <div className="col-md-4 d-flex flex-column">
      <div className="card shadow flex-grow-1">
        <div className="card-body d-flex flex-column">
          <h2 className="card-title text-center text-primary mb-4">
            Planograma
          </h2>

          {/* Mostrar el input solo si no hay imagen */}
          {!selectedImage && (
            <div className="mb-3">
              <label htmlFor="image-input" className="form-label">
                Cargar imagen del Planograma
              </label>
              <input
                id="image-input"
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
                className="form-control"
              />
            </div>
          )}

          {selectedImage && (
            <div className="mb-3 text-center flex-grow-1 d-flex flex-column align-items-center">
              <img
                src={URL.createObjectURL(selectedImage)}
                alt="Preview"
                className="img-thumbnail"
                style={{ width: "100%", maxHeight: "300px", objectFit: "contain" }}
              />
              <div className="mt-3 d-flex justify-content-center gap-3">
                <button className="btn btn-danger" onClick={handleRemoveImage}>
                  Quitar imagen
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>

    {/* Columna central y derecha - Carrusel */}
    <div className="col-md-8 d-flex flex-column">
      <div
        id="imageCarousel"
        className="carousel slide my-4 flex-grow-1"
        data-bs-interval="false" // 🔹 Evita el auto avance
      >
        <div className="carousel-inner">
          {resultadosIA.map((resultado, index) => {
            const registro = resgistros.find((reg) =>
              reg.fotos.some((foto) => foto.foto === resultado.fotoUrl)
            );

            return (
              <div
                key={resultado.fotoUrl}
                className={`carousel-item ${index === 0 ? 'active' : ''}`}
              >
                <div className="row d-flex align-items-stretch">
                  {/* Columna central: Imagen */}
                  <div className="col-md-6 d-flex flex-column">
                    <div className="flex-grow-1 d-flex align-items-center justify-content-center">
                      <img
                        src={resultado.fotoUrl}
                        alt="image-form"
                        className="d-block w-100"
                        style={{ maxHeight: "300px", objectFit: "contain" }}
                      />
                    </div>
                    <div className="mt-3 text-center">
                      <h6 style={{ fontSize: '2vh', fontWeight: 'bolder' }}>
                        {registro?.establecimiento || 'Establecimiento no disponible'}
                      </h6>
                      <p>{registro?.promotor || 'Promotor no disponible'}</p>
                      <p>{registro?.fecha_Sincronizado || 'Fecha no disponible'}</p>
                      <p>Coordenadas: {registro?.coordenadas || 'Coordenadas no disponibles'}</p>
                    </div>
                  </div>

                  {/* Columna derecha: Explicación IA */}
                  <div className="col-md-6 d-flex flex-column">
                    <div className="d-flex justify-content-end mb-3 align-items-center">
                      {resultadosIA.length > 0 && (
                        <div className="text-white me-3 p-2 bg-dark rounded" style={{ fontSize: '0.9rem' }}>
                          {currentIndex + 1} / {resultadosIA.length}
                        </div>
                      )}
                      <FontAwesomeIcon
                        className="icon-status"
                        style={{ cursor: 'pointer' }}
                        icon={faDownload}
                        onClick={() => handleClick(resultado)}
                      />
                    </div>
                    <div
                      className="flex-grow-1"
                      style={{
                        backgroundColor: "#f8f9fa",
                        padding: "1rem",
                        border: "1px solid #dee2e6",
                        borderRadius: "0.375rem",
                        height: "100%",
                        minHeight: "350px",
                        maxHeight: "400px",
                        overflowY: "auto",
                        whiteSpace: "pre-wrap",
                        textAlign: "start",
                      }}
                    >
                      {resultado.resultado
                        ? resultado.resultado.split("\n").map((line, index) => (
                            <span key={index}>
                              {line}
                              <br />
                            </span>
                          ))
                        : "El resultado aparecerá aquí después del análisis."}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Botones de navegación */}
        {resultadosIA.length > 0 && (
          <>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#imageCarousel"
              data-bs-slide="prev"
              onClick={() => setCurrentIndex((prev) => (prev > 0 ? prev - 1 : resultadosIA.length - 1))}
              style={{
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'absolute',
                top: '50%',
                left: '-20px',
                transform: 'translateY(-50%)'
              }}
            >
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Anterior</span>
            </button>

            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#imageCarousel"
              data-bs-slide="next"
              onClick={() => setCurrentIndex((prev) => (prev < resultadosIA.length - 1 ? prev + 1 : 0))}
              style={{
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'absolute',
                top: '50%',
                right: '-20px',
                transform: 'translateY(-50%)'
              }}
            >
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Siguiente</span>
            </button>
          </>
        )}
      </div>
    </div>
  </div>
</div>
</div>


</div>
            <LoadPanel visible={LoadPanelBoolean} />
        </div>
    );
}
